import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { __DEV__ } from '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import Box from '../Box/index.esm.js';
import Badge from '../Badge/index.esm.js';
import useTextStyles from './styles.esm.js';

var Text = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$as = props.as,
      as = _props$as === void 0 ? 'p' : _props$as,
      truncate = props.truncate,
      rest = _objectWithoutPropertiesLoose(props, ["as", "truncate"]);

  if (as === 'kbd') {
    return React__default.createElement(Badge, _extends({
      as: "kbd",
      ref: ref,
      padding: "p-1",
      fontFamily: "font-sans",
      boxShadow: "shadow-sm",
      borderWidth: ['border', 'border-b-2'],
      borderColor: "border-gray-300"
    }, rest));
  }

  return React__default.createElement(Box, _extends({
    ref: ref,
    as: as
  }, useTextStyles(as, truncate), rest));
});

if (__DEV__) {
  Text.displayName = 'Text';
}

export default Text;
//# sourceMappingURL=index.esm.js.map
